import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePackageConfirmationMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  itinerary: GraphQLTypes.Scalars['String'];
}>;


export type CreatePackageConfirmationMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'createPackageConfirmation'>
);


export const CreatePackageConfirmationDocument = /*#__PURE__*/ gql`
    mutation createPackageConfirmation($packageId: String!, $itinerary: String!) {
  createPackageConfirmation(packageId: $packageId, itinerary: $itinerary)
}
    `;

/**
 * __useCreatePackageConfirmationMutation__
 *
 * To run a mutation, you first call `useCreatePackageConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackageConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackageConfirmationMutation, { data, loading, error }] = useCreatePackageConfirmationMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      itinerary: // value for 'itinerary'
 *   },
 * });
 */
export function useCreatePackageConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackageConfirmationMutationResult, CreatePackageConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackageConfirmationMutationResult, CreatePackageConfirmationMutationVariables>(CreatePackageConfirmationDocument, options);
      }
export type CreatePackageConfirmationMutationHookResult = ReturnType<typeof useCreatePackageConfirmationMutation>;